// extracted by mini-css-extract-plugin
export default {"overlay":"ErrorPopup_overlay__YOlTt","popup":"ErrorPopup_popup__c1qsc","buttonGroup":"ErrorPopup_buttonGroup__OI1oJ"};